import { render, staticRenderFns } from "./DetalleLiquidacionCompra.vue?vue&type=template&id=19b0ef5d&scoped=true&lang=pug&"
import script from "./DetalleLiquidacionCompra.vue?vue&type=script&lang=js&"
export * from "./DetalleLiquidacionCompra.vue?vue&type=script&lang=js&"
import style0 from "./DetalleLiquidacionCompra.vue?vue&type=style&index=0&id=19b0ef5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b0ef5d",
  null
  
)

export default component.exports